import React, { useEffect } from 'react';
import { useAppDispatch } from '../../hooks/redux';
import { setSelectedAccountId } from '../../store/analyticsSlice';
import { StorageManager } from '../../utils/storageManager';

// Компонент для восстановления сохранённых данных при запуске приложения
interface DataHydratorProps {
  children: React.ReactNode;
}

const DataHydrator: React.FC<DataHydratorProps> = ({ children }) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    // Загружаем сохранённые предпочтения пользователя только один раз при монтировании
    const preferences = StorageManager.getPreferences();
    
    // Восстанавливаем выбранный аккаунт, если он был
    if (preferences.selectedAccountId !== null) {
      dispatch(setSelectedAccountId(preferences.selectedAccountId));
    }
  }, [dispatch]); // Пустой массив зависимостей - выполнится только при монтировании

  return <>{children}</>;
};

export default DataHydrator;